import { z } from 'zod';
import { ThemeSchema } from './common';

export const UpdateUserSettingsSchema = z.object({
  theme: ThemeSchema,
});
export type UpdateUserSettingsRequest = z.infer<typeof UpdateUserSettingsSchema>;

export const GlobalSettingsKeys = [
  'defaultIrpfPct',
  'defaultIvaPct',
  'dueDateDays',
  'fiscalYear',
  'bankBalance',
  'monthlyRecurringExpenses',
  'dsoTargetDays',
  'dsoIndustryDays',
] as const;

export const UpdateGlobalSettingsSchema = z.object({
  defaultIrpfPct: z.number().min(0).max(100).optional(),
  defaultIvaPct: z.number().min(0).max(100).optional(),
  dueDateDays: z.number().int().min(0).max(365).optional(),
  fiscalYear: z.number().int().min(2000).max(2100).optional(),
  bankBalance: z.number().optional(),
  monthlyRecurringExpenses: z.number().min(0).optional(),
  dsoTargetDays: z.number().int().min(0).max(365).optional(),
  dsoIndustryDays: z.number().int().min(0).max(365).optional(),
});
export type UpdateGlobalSettingsRequest = z.infer<typeof UpdateGlobalSettingsSchema>;
